import { notify } from 'utils/reduxUtils';

export const types = {
  FETCH_GLOBAL_EXPEDITE_OPTIONS_ERROR:
    'settings/digitalQuote/FETCH_GLOBAL_EXPEDITE_OPTIONS_ERROR',
  FETCH_GLOBAL_EXPEDITE_OPTIONS_SUCCESS:
    'settings/digitalQuote/FETCH_GLOBAL_EXPEDITE_OPTIONS_SUCCESS',

  UPDATE_EXPEDITE_SETTINGS_ERROR:
    'settings/digitalQuote/UPDATE_EXPEDITE_SETTINGS_ERROR',
  UPDATE_EXPEDITE_SETTINGS_REQUEST:
    'settings/digitalQuote/UPDATE_EXPEDITE_SETTINGS_REQUEST',
  UPDATE_EXPEDITE_SETTINGS_SUCCESS:
    'settings/digitalQuote/UPDATE_EXPEDITE_SETTINGS_SUCCESS',
};

export const fetchGlobalExpediteOptions = {
  error: () => ({
    type: types.FETCH_GLOBAL_EXPEDITE_OPTIONS_ERROR,
  }),
  success: ({ globalExpediteOptions }) => ({
    type: types.FETCH_GLOBAL_EXPEDITE_OPTIONS_SUCCESS,
    payload: { globalExpediteOptions },
  }),
};

export const updateExpediteSettings = {
  error: notify(
    (error) => ({
      type: types.UPDATE_EXPEDITE_SETTINGS_ERROR,
      payload: error,
    }),
    "Can't update expedite settings",
  ),
  request: ({ expediteOptions, standardLeadTime }) => ({
    type: types.UPDATE_EXPEDITE_SETTINGS_REQUEST,
    payload: { expediteOptions, standardLeadTime },
  }),
  success: notify(
    ({ globalExpediteOptions }) => ({
      type: types.UPDATE_EXPEDITE_SETTINGS_SUCCESS,
      payload: { globalExpediteOptions },
    }),
    'Expedite settings updated successfully.',
  ),
};
